const InstanceTitle = ({ record }) => {
    return <span>Instance {record ? `"${record.name}"` : ''}</span>;
};

export default InstanceTitle;